import React from "react";
import type { ReactNode } from "react";
import Error from "assets/UnAuthorized/error.png";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className='flex flex-col justify-center items-center min-h-screen bg-gray-100'>
          <div className='flex justify-center gap-8 mb-8'>
            <img
              src={Error}
              alt='under maintenance image'
              className='w-[70vw] md:w-[30vw] cursor-pointer items-center'
            ></img>
          </div>

          <h1 className='text-p2 sm:text-p1 md:text-h4 text-center font-semibold text-gray-800'>
            Oops! It seems we’ve hit a snag. Let’s sort this out right away.
          </h1>
        </div>
      );
    }

    return this.props.children;
  }
}
